var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"1.25703","height":"21.3694","rx":"0.628513","transform":"matrix(0.707111 -0.707103 0.707111 0.707103 0 0.888672)","fill":"#141414","key":0}),React.createElement("rect",{"width":"1.25703","height":"21.3694","rx":"0.628513","transform":"matrix(-0.707111 -0.707103 0.707111 -0.707103 0.888672 16)","fill":"#141414","key":1})]);
}

Close.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Close;

Close.default = Close;
